import React from "react"
import game from "gamao.png"

const Gamao = props => <img src={game} className="game" {...props} />

export default Gamao
